import {
  conteudoMinistradoDataStore
} from '../../../../../../store/lancamento-aula/step-1/conteudo-ministrado-data.store';
import { FormEvent } from 'react';
import {
  ICreateConteudoMinistradoDTO
} from '../../../../../../models/happy-code-api.model';
import {
  useNotificationService
} from '../../../../../../services/notification.service';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useLearnConteudoMinistradoService
} from '../../../../../../services/learn/learn-conteudo-ministrado.service';
import { useGlobalContext } from '../../../../../../context/GlobalContext';
import { useTranslation } from 'react-i18next';

interface UseConteudoMinistradoFormProps {
  navigateToNextStepOnSuccess?: boolean;
  resetAfterSuccess?: boolean;
  onSuccess?: () => void;
}

export default function useConteudoMinistradoForm({
  navigateToNextStepOnSuccess = true,
  resetAfterSuccess = true,
  onSuccess
}: UseConteudoMinistradoFormProps = {}) {
  const { setIsGlobalLoading } = useGlobalContext();
  const service = useLearnConteudoMinistradoService();
  const notificationService = useNotificationService();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation(['gestao_de_aulas']);
  const {
    conteudoMinistradoData,
    resetConteudoMinistradoData
  } = conteudoMinistradoDataStore();

  const submitForm = async (
    event: FormEvent<HTMLFormElement>
  ): Promise<void> => {
    event.preventDefault();
    setIsGlobalLoading(true);

    const formObject = buildFormObject();

    await service
      .createConteudoMinistrado(formObject)
      .then(() => handleSuccess())
      .catch(() => handleError())
      .finally(() => setIsGlobalLoading(false));
  };

  const buildFormObject = (): ICreateConteudoMinistradoDTO => ({
    idTipoConteudo: conteudoMinistradoData.tipo,
    idConteudo: 100,
    tituloConteudo: conteudoMinistradoData.conteudoDescricao,
    descricao: conteudoMinistradoData.descricao,
    idAula: Number(id)
  });


  const handleSuccess = () => {
    notificationService({
      message: t('gestao_de_aulas:taughtContent'),
      description: t('gestao_de_aulas:contentRegisteredSuccess'),
      type: 'success'
    });

    if (navigateToNextStepOnSuccess)
      navigate(`/turmas/professor/lancamento-aula/create/step-1/${id}`);

    if (resetAfterSuccess)
      resetConteudoMinistradoData();

    onSuccess?.();
  };

  const handleError = () => {
    notificationService({
      message: t('gestao_de_aulas:taughtContent'),
      description: t('gestao_de_aulas:contentRegisteredError'),
      type: 'error'
    });
  };

  return {
    formObject: {
      submitForm
    }
  };
}
